import { render } from "./external-exam-list.vue?vue&type=template&id=65c1743c&scoped=true"
import script from "./external-exam-list.vue?vue&type=script&lang=js"
export * from "./external-exam-list.vue?vue&type=script&lang=js"

import "./external-exam-list.vue?vue&type=style&index=0&id=65c1743c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c1743c"]])

export default __exports__